<template>
  <div class='about-page'>
    <HeroImage
      title='About <span class="text-nowrap">JORNAY PM</span>'
      subtitle='Wake up to a treatment for<br> ADHD that’s taken at night.'
      :image='heroImg'
      :image__sm='imageSm'
    >
    </HeroImage>

    <AboutHowIsDifferent />
    <AboutProven />
    <WhyHelpFind />

    <PageNav :menus='navItems' />

    <InfoBlockSticky />
    <InfoBlock class='trigger' />
    <Footer />
  </div>
</template>

<script>
import HeroImage from '../components/elements/HeroImage'
import heroImg from '../assets/images/3_25/about/hero@2x.webp'
import imageSm from "../assets/images/3_25/about/hero_s@2x.webp"
import heroVideo from '../assets/videos/SoccerScene_FULL_v4.mp4'
import heromobileVideo from '../assets/videos/compressed/SoccerScene_1.mp4'
import InfoBlockSticky from '../components/sections/InfoBlockSticky'
import InfoBlock from '../components/sections/InfoBlock'
import Footer from '../components/sections/Footer'
import ogImage from '../assets/images/Jornay_OG_Image.jpg'
import PageNav from '../components/elements/PageNav.vue'
import AboutHowIsDifferent from '../components/sections/AboutHowIsDifferent.vue'
import AboutProven from '../components/sections/AboutProven.vue'
import WhyHelpFind from '../components/sections/WhyHelpFind.vue'

export default {
  name: 'about-page',
  metaInfo: {
    title: 'JORNAY PM® (methylphenidate HCI) for ADHD Treatment',
    link: [
      {
        rel: 'canonical',
        href: 'https://www.jornaypm.com/about-jornay-pm'
      }
    ],
    meta: [
      {
        name: 'description',
        content:
          'Taken once nightly, JORNAY PM® (methylphenidate HCI) is designed to provide symptom control for ADHD throughout the day. Please see full Prescribing Information, including Boxed Warning, and Medication Guide'
      },
      {
        property: 'og:title',
        content: 'JORNAY PM® (methylphenidate HCI) for ADHD Treatment'
      },
      {
        property: 'og:description',
        content:
          'Taken once nightly, JORNAY PM® (methylphenidate HCI) is designed to provide symptom control for ADHD throughout the day. Please see full Prescribing Information, including Boxed Warning, and Medication Guide'
      },
      {
        property: 'og:image',
        content: ogImage
      },
      {
        property: 'google-site-verification',
        content: 'ARK4dFoz7A2muCj6LE7Z_Pf2IbIg41HtT0dLwNgni8I'
      }
    ]
  },
  components: {
    HeroImage,
    InfoBlockSticky,
    InfoBlock,
    Footer,
    PageNav,
    AboutHowIsDifferent,
    AboutProven,
    WhyHelpFind
  },
  data () {
    return {
      heroVideo,
      HeroImage,
      heroImg,
      imageSm,
      heromobileVideo,
      navItems: [
        {
          title: 'Interested in JORNAY&nbsp;PM?',
          routerLinkName: 'Resources',
          ctaText: 'Learn more'
        },
        {
          title: 'See how JORNAY&nbsp;PM is designed',
          routerLinkName: 'How',
          ctaText: 'Find out'
        }
      ]
    }
  }
}
</script>

<style scoped></style>
